<template>
  <div class="wtyradio" style="border:none;">
    <div class="wtyradio">
      <div
        v-for="(item, index) in radioList"
        :key="index"
        :class="item.value == radio_checked ? 'wtydadio-item-checked' : 'wtydadio-item'"
        :style="index==radioList.length-1?'border-right:none;':''"
        @click="checkedChange(item)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "wtyRadio",
  props: ["radioList", "checked"],
  data() {
    return {
      radio_checked: this.checked
    };
  },
  methods: {
    checkedChange(item) {
      this.radio_checked = item.value;
      this.$emit("wtyRadioChange", this.radio_checked);
    }
  }
};
</script>
<style lang="less" scoped>
.wtyradio {
  height: 40px;
  // background-color: rgb(142, 37, 37);
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: auto;
  overflow: hidden;
  border: 1px solid #DCDFE6;
  background-color:#fff;
  .wtydadio-item {
    width: auto;
    padding: 0 20px;
    cursor: pointer;
    border-right: 1px solid #DCDFE6;
  }
  .wtydadio-item:hover{
    color:#409eff;
  }
  .wtydadio-item-checked {
    background-color: #409eff;
    color:#fff;
    width: auto;
    padding: 0 20px;
    cursor: pointer;
    border-right: 1px solid #DCDFE6;
  }
}
</style>
